(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PaymentConfirmationSlipsListController', PaymentConfirmationSlipsListController)

    /** @ngInject */
    function PaymentConfirmationSlipsListController($q, $stateParams, HelperService, UnitService, PaymentSlipService, PaymentSlipConfirmationService, sweetAlert) {
        const vm = this;
        const paymentConfirmationRemittanceId = $stateParams.paymentConfirmationRemittanceId;
        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedUnit)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedUnit)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                vm.isFirstCall = false;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedUnit = null;
            vm.paymentSlips = [];
            vm.isFirstCall = true;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getPaymentSlips(start, number, tableState);
        }

        vm.getUnits = search => {
            if (!search) {
                vm.units = [];
                return;
            }

            vm.units = vm.allUnits.filter(unit => filterUnit(unit, search))
        }

        vm.getPaymentStatusText = PaymentSlipService.getPaymentStatusText;
        vm.getPaymentStatusClass = PaymentSlipService.getPaymentStatusClass;

        vm.deletePaymentSlip = paymentSlipId => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.page-content');

                    PaymentSlipService
                        .delete(paymentSlipId)
                        .then(
                            () => {
                                vm.tableCallServer();

                                HelperService.stopLoading('.page-content');
                                HelperService.successCallback('delete');
                            }, error => {
                                HelperService.errorCallback(error);
                                HelperService.stopLoading('.page-content');
                            })
                }
            })
        }

        init();

        function filterUnit(unit, search) {
            if (unit.CorporateName == null)
                unit.CorporateName = '';

            if (unit.FantasyName == null)
                unit.FantasyName = '';

            if (unit.FantasyName.toLowerCase().includes(search.toLowerCase()) || unit.CorporateName.toLowerCase().includes(search.toLowerCase()) || unit.UniqueCode.toString().includes(search) || unit.ExternalCode.toString().includes(search))
                return unit;
        }

        function getPaymentRemittance() {
            if (!paymentConfirmationRemittanceId) {
                HelperService.stopLoading('.page-loader');
                return;
            }

            return PaymentSlipConfirmationService
                .get(paymentConfirmationRemittanceId)
                .then(success => vm.paymentRemittanceData = success,
                    error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.page-loader');
                    })
        }

        function getPaymentSlips(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PaymentSlipService
                .getByParameters(parameters)
                .then(success => {
                    vm.paymentSlips = success.Slips;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.paymentSlips = null;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'PaymentDueDate',
                OrderDescending: false,
                PaymentConfirmationRemittanceId: paymentConfirmationRemittanceId
            }

            if (vm.selectedUnit) {
                isTableSearch = true;
                params.UnitId = vm.selectedUnit.Id;
            }

            return params;
        }

        function getAllUnitsResumed() {
            return UnitService
                .getAllResumed()
                .then(success => vm.allUnits = success,
                    error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.custom-filters');
                    })
        }

        function init() {
            vm.selectedUnit;
            vm.isLoading = false;
            vm.isFirstCall = true;

            HelperService.startLoading('.page-loader');

            $q.all([getAllUnitsResumed(), getPaymentRemittance()])
                .then(() => {
                    HelperService.stopLoading('.page-loader');
                })
        }
    }
}());